import React, { Component } from "react";
import 'antd/dist/antd.css';
import { Spinner } from 'reactstrap';
import axios from '../../../utils/request';


export class CCCCLTDJumpInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isReady: false,
            isLoading: true,
            errorMessage: "",

        }
    };
    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const commonParamater = urlParams.get("commonParamater");
        const tenantId = urlParams.get("tenantId"); 
        this.loadPage(tenantId, commonParamater);
    };
    loadPage = (tenantId, commonParamater) => {
        const params = {
            tenantId,
            commonParamater
        }
        axios
            .get("/api/CCCCLTD/GetOAJumpUrl", { params: params })
            .then(res => {
                const reqCode = res.data.code;
                const oaJump = res.data.data
                let errorMessage = "";
                if (reqCode != "200") {
                    errorMessage = "获取员工详情跳转链接失败！错误信息：" + res.data.message;
                } else {
                    if (oaJump["isUrl"]) {
                        window.location.href = oaJump["value"];
                    } else {
                        errorMessage = oaJump["value"];
                    }
                }
                this.setState({ isLoading: false, isReady: true, errorMessage });
            })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "获取员工详情跳转链接异常，请联系管理员！" + reason.response.data.message });
            })
            .finally(
            );
    };
    render() {
        if (this.state.isReady) {
            if (this.state.errorMessage !== "") {
                return (<div style={{ textAlign: "center", padding: "32px" }}><span style={{ color: "red" }}>{this.state.errorMessage}</span></div>)
            }
        }
        else {
            return (
                <div style={{ textAlign: "center", padding: "15px" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }

    }
}